<div class="table-container">
  <div class="button-container">
    @if (showClearAllFilters) {
      <button (click)="clearAllFilters()"
        class="btn-secondary clear-all-filters-button"
        data-cy="spo-list-clear-all-filters-button">Clear all filters
      </button>
    }
  </div>
  <table class="list-table" data-cy="spo-list">
    <thead>
      <tr class="list-row">
        <th class="list-header-element-button"></th>
        @if (hasPartnerColumn()) {
          <th
            class="list-header-element spo-partner-column"
            data-cy="spo-list-header-partner">
            <div class="label-and-filter">
              <app-tooltip message="Partner">
                <span (click)="sortingBy(FilterColumnsEnum.PARTNER, partnerArrowUp); arrowToggle()"
                  class="sortable"
                  data-cy="spo-list-header-arrow-button-partner">
                  <span class="sortable" data-cy="spo-list-header-name-partner">Partner</span>
                  <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                    @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.PARTNER) {
                      <span
                        [ngClass]="{'iwp-icon-gen_arrow_down': !partnerArrowUp, 'iwp-icon-gen_arrow_up': partnerArrowUp}"
                        class="sortable-arrow"
                        data-cy="spo-list-header-arrow-partner">
                      </span>
                    }
                  </app-tooltip>
                </span>
              </app-tooltip>
              <app-code-filter #partnerFilterComponent
                (filterEvent)="onFilterChange($event)"
                (onOpen)="getPartnerGroupOptions()"
                [dataSubject]="partnerFilterSubject"
                [filterName]="FilterColumnsEnum.PARTNER"
                [placeHolder]="'Search partner'"
                class="filter-button"
              data-cy="spo-list-partner-filter"></app-code-filter>
            </div>
          </th>
        }
        <th class="list-header-element spo-supplying-packing-plant-column"
          data-cy="spo-list-header-supplying-packing-plant">
          <div class="label-and-filter">
            <app-tooltip message="Supplying Packing Plant">
              <span (click)="sortingBy(FilterColumnsEnum.SUPPLYING_PACKING_PLANT, supplyingPackingPlantArrowUp); arrowToggle()"
                class="sortable"
                data-cy="spo-list-header-arrow-button-supplying-packing-plant">
                <span class="sortable" data-cy="spo-list-header-name-supplying-packing-plant">Supplying Packing Plant</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.SUPPLYING_PACKING_PLANT) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !supplyingPackingPlantArrowUp, 'iwp-icon-gen_arrow_up': supplyingPackingPlantArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-supplying-packing-plant">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-code-filter #supplyingPackingPlantFilterComponent
              (filterEvent)="onFilterChange($event)"
              (onOpen)="getSupplyingPackingPlants()"
              [dataSubject]="supplyingPackingPlantFilterSubject"
              [filterName]="FilterColumnsEnum.SUPPLYING_PACKING_PLANT"
              placeHolder="Search Supplying Packing Plant"
              class="filter-button"
            data-cy="spo-list-supply-packing-plant-filter"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element spo-number-column" data-cy="spo-list-header-number">
          <div class="label-and-filter">
            <app-tooltip message="SPO number">
              <span (click)="sortingBy(FilterColumnsEnum.NUMBER, numberArrowUp); arrowToggle()"
                class="sortable"
                data-cy="spo-list-header-arrow-button-number">
                <span class="sortable" data-cy="spo-list-header-name-number">SPO number</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.NUMBER) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !numberArrowUp, 'iwp-icon-gen_arrow_up': numberArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-number">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-input-and-code-filter #numberFilterComponent
              (filterEvent)="onFilterChange($event)"
              (onOpen)="getSpecialOrderStatusOptions()"
              [dataSubject]="statusFilterSubject"
              [filterName]="FilterColumnsEnum.NUMBER"
              [placeHolder]="'Search SPO number'"
              class="filter-button"
              data-cy="spo-list-number-filter"
            formatWithoutCode="true"></app-input-and-code-filter>
          </div>
        </th>
        <th class="list-header-element spo-sent-date-column" data-cy="spo-list-header-sent-date">
          <div class="label-and-filter">
            <app-tooltip message="Sent date">
              <span (click)="sortingBy(FilterColumnsEnum.SENT_DATE, sentDateArrowUp); arrowToggle()"
                data-cy="spo-list-header-arrow-button-sent-date">
                <span class="sortable" data-cy="spo-list-header-name-sent-date">Sent date</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.SENT_DATE) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !sentDateArrowUp, 'iwp-icon-gen_arrow_up': sentDateArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-sent-date">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-date-filter #sentDateFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dateDisplayedInUtc]="true"
              [filterName]="FilterColumnsEnum.SENT_DATE"
            class="filter-button"></app-date-filter>
          </div>
        </th>
        <th class="list-header-element spo-materials-column numeric" data-cy="spo-list-header-materials">
          <div class="label-and-filter">
            <app-tooltip message="Materials">
              <span (click)="sortingBy(FilterColumnsEnum.NUMBER_OF_MATERIALS, materialsArrowUp); arrowToggle()"
                class="sortable"
                data-cy="spo-list-header-arrow-button-materials">
                <span class="sortable" data-cy="spo-list-header-name-materials">Materials</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.NUMBER_OF_MATERIALS) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !materialsArrowUp, 'iwp-icon-gen_arrow_up': materialsArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-materials">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-input-and-number-filter #materialsFilterComponent
              (filterEvent)="onFilterChange($event)"
              [disableInputFilter]="false"
              [filterName]="FilterColumnsEnum.NUMBER_OF_MATERIALS"
              class="filter-button"
              placeholder="Search material"
            operatorPlaceholder="Number of materials"></app-input-and-number-filter>
          </div>
        </th>
        <th class="list-header-element spo-reason-column"
          data-cy="spo-list-header-reason">
          <div class="label-and-filter">
            <app-tooltip message="Reason">
              <span (click)="sortingBy(FilterColumnsEnum.REASON, reasonArrowUp); arrowToggle()"
                class="sortable"
                data-cy="spo-list-header-arrow-button-reason">
                <span class="sortable" data-cy="spo-list-header-name-reason">Reason</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.REASON) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !reasonArrowUp, 'iwp-icon-gen_arrow_up': reasonArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-reason">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-code-filter #reasonFilterComponent
              (filterEvent)="onFilterChange($event)"
              (onOpen)="getReasonOptions()"
              [dataSubject]="reasonFilterSubject"
              [filterName]="FilterColumnsEnum.REASON"
              [hasEmptyOption]="true"
              [placeHolder]="'Search reason'"
              class="filter-button"
            data-cy="spo-list-reason-filter"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element spo-changed-on-column" data-cy="spo-list-header-changed-on">
          <div class="label-and-filter">
            <app-tooltip message="Changed on">
              <span (click)="sortingBy(FilterColumnsEnum.LAST_CHANGE_DATETIME, changedOnArrowUp); arrowToggle()"
                data-cy="spo-list-header-arrow-button-changed-on">
                <span class="sortable" data-cy="spo-list-header-name-changed-on">Changed on</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.LAST_CHANGE_DATETIME) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !changedOnArrowUp, 'iwp-icon-gen_arrow_up': changedOnArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-changed-on">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-date-filter #changedOnFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dateDisplayedInUtc]="true"
              [filterName]="FilterColumnsEnum.LAST_CHANGE_DATETIME"
            class="filter-button"></app-date-filter>
          </div>
        </th>
        <th class="list-header-element spo-requested-date-column" data-cy="spo-list-header-requested-date">
          <div class="label-and-filter">
            <app-tooltip message="Requested date">
              <span (click)="sortingBy(FilterColumnsEnum.REQUESTED_DATE, requestedDateArrowUp); arrowToggle()"
                data-cy="spo-list-header-arrow-button-requested-date">
                <span class="sortable" data-cy="spo-list-header-name-requested-date">Requested date</span>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="Sort">
                  @if (spoSearchCriteriaService.sortedBy === FilterColumnsEnum.REQUESTED_DATE) {
                    <span
                      [ngClass]="{'iwp-icon-gen_arrow_down': !requestedDateArrowUp, 'iwp-icon-gen_arrow_up': requestedDateArrowUp}"
                      class="sortable-arrow"
                      data-cy="spo-list-header-arrow-requested-date">
                    </span>
                  }
                </app-tooltip>
              </span>
            </app-tooltip>
            <app-date-filter #requestedDateFilterComponent
              (filterEvent)="onFilterChange($event)"
              [dateDisplayedInUtc]="false"
              [filterName]="FilterColumnsEnum.REQUESTED_DATE"
              [hasEmptyOption]="true"
            class="filter-button"></app-date-filter>
          </div>
        </th>
        <th class="list-header-element spo-status-column" data-cy="spo-list-header-status">
          <div class="label-and-filter">
            <app-tooltip message="Status">
              <span data-cy="spo-list-header-arrow-button-status">
                <span data-cy="spo-list-header-name-status">Status</span>
              </span>
            </app-tooltip>
            <app-code-filter #specialOrderMaterialStatusFilterComponent
              (filterEvent)="onFilterChange($event)"
              (onOpen)="getSpecialOrderMaterialStatusOptions()"
              [dataSubject]="materialStatusFilterSubject"
              [filterName]="FilterColumnsEnum.SPO_MAT_STATUS"
              class="filter-button"
              data-cy="spo-list-status-filter"
              disableInputFilter="true"
            formatWithoutCode="true"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element spo-alerts-column" data-cy="spo-list-header-alerts">
          <div class="label-and-filter">
            <app-tooltip message="Alerts">
              <span data-cy="spo-list-header-arrow-button-alerts">
                <span data-cy="spo-list-header-name-alerts">Alerts</span>
              </span>
            </app-tooltip>
            <app-code-filter #materialAlertsFilterComponent
              (filterEvent)="onFilterChange($event)"
              [codes]="materialAlertsOptions"
              [filterName]="FilterColumnsEnum.MATERIAL_ALERTS"
              [hasEmptyOption]="true"
              class="filter-button"
              data-cy="spo-list-alerts-filter"
              disableInputFilter="true"
            formatWithoutCode="true"></app-code-filter>
          </div>
        </th>
        <th class="list-header-element context-menu-header">
          <!-- empty header-->
        </th>
      </tr>
    </thead>

    @if (!isLoading) {
      <tbody>
        @for (item of specialOrderItems; track item) {
          <tr [ngClass]="{'list-row': true, 'is-open': item.isOpen}" data-cy="spo-list-row">
            <td class="list-element-button">
              <div (click)="accordionChangeState(item)"
                         [ngClass]="{'accordion-btn': showQuickView(item.specialOrder),
                     'accordion-btn-disable': !showQuickView(item.specialOrder), 'arrow-button': true}"
                data-cy="spo-list-row-arrow-button">
                <app-tooltip [disable]="!showQuickView(item.specialOrder)"
                  [dynamic]="false"
                  class="display-inline-flex"
                  message="SPO quick view">
                            <span [ngClass]="{'iwp-icon-gen_arrow_right': !item.isOpen,
                                 'iwp-icon-gen_arrow_down': item.isOpen}">
                  </span>
                </app-tooltip>
              </div>
            </td>
            @if (hasPartnerColumn()) {
              <td
                class="list-element dynamic">
                <app-tooltip message="{{item.specialOrder.partner?.code}} {{item.specialOrder.partner?.name}}">
                  <span data-cy="spo-list-element-partner">{{item.specialOrder.partner?.code}} {{item.specialOrder.partner?.name}}</span>
                </app-tooltip>
              </td>
            }
            <td class="list-element">
              <app-tooltip message="{{item.specialOrder.supplyingPackingPlant | prettyPrintReference}}">
                <span data-cy="spo-list-element-supplying-packing-plant">{{item.specialOrder.supplyingPackingPlant | prettyPrintReference}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              <app-tooltip [dynamic]="false" class="display-inline-flex"
                message="{{item.specialOrder.status.description}}">
                <span data-cy="spo-list-spo-status-dot">
                  <app-status-dot [ngClass]="['status', item.specialOrder.status.code]"></app-status-dot>
                </span>
              </app-tooltip>
              <span class="spo-list-element-number"
              data-cy="spo-list-element-number">{{item.specialOrder.number}}</span>
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.specialOrder.sentDate | date:'dd-MM-yyyy HH:mm:ss'}}">
                <span data-cy="spo-list-element-sent-date">{{item.specialOrder.sentDate | date:'dd-MM-yyyy HH:mm:ss' | undefinedValue}}</span>
              </app-tooltip>
            </td>
            <td [ngClass]="{'numeric': item.specialOrder.numberOfMaterials !== 0}" class="list-element">
              @if (item.specialOrder.numberOfMaterials === 0) {
                <app-warning-inline
                  [warningInlineLabel]="requiredForSendLabel"
                  [warningType]="WarningTypeEnum.WARNING_SEND"
                  class="required-warning"
                data-cy="spo-list-element-materials-required-warning"></app-warning-inline>
              }
              @if (item.specialOrder.numberOfMaterials !== 0) {
                <span
                data-cy="spo-list-element-materials">{{item.specialOrder.numberOfMaterials}}</span>
              }
            </td>
            <td class="list-element dynamic">
              @if (!item.specialOrder.reason) {
                <app-warning-inline
                  [warningInlineLabel]="requiredForSendLabel"
                  [warningType]="WarningTypeEnum.WARNING_SEND"
                  class="required-warning"
                data-cy="spo-list-element-reason-required-warning"></app-warning-inline>
              }
              @if (item.specialOrder.reason) {
                <span>
                  <app-tooltip message="{{item.specialOrder.reason | prettyPrintReference}}" placement="bottom">
                    <span data-cy="spo-list-element-reason">{{item.specialOrder.reason | prettyPrintReference}}</span>
                  </app-tooltip>
                </span>
              }
            </td>
            <td class="list-element">
              <app-tooltip message="{{item.specialOrder.lastChangeDatetime | date:'dd-MM-yyyy HH:mm:ss'}}">
                <span data-cy="spo-list-element-change-date">{{item.specialOrder.lastChangeDatetime | date:'dd-MM-yyyy HH:mm:ss'}}</span>
              </app-tooltip>
            </td>
            <td class="list-element">
              @if (!item.specialOrder.requestedDate) {
                <app-warning-inline
                  [warningInlineLabel]="requiredForSendLabel"
                  [warningType]="WarningTypeEnum.WARNING_SEND"
                  class="required-warning"
                data-cy="spo-list-element-requested-date-required-warning"></app-warning-inline>
              }
              @if (item.specialOrder.requestedDate) {
                <span>
                  <app-tooltip
                    message="{{item.specialOrder.requestedDate | utcAsLocal | date:'dd-MM-yyyy' | undefinedValue}}">
                    <span data-cy="spo-list-element-requested-date">{{item.specialOrder.requestedDate | utcAsLocal | date:'dd-MM-yyyy' | undefinedValue}}</span>
                  </app-tooltip>
                </span>
              }
            </td>
            <td class="list-element">
              <app-status-bar
              [statusArray]="retrieveIStatusBar(item.specialOrder.materialStatusGroups)"></app-status-bar>
            </td>
            <td class="list-element">
              @if (hasAlertsText(item.specialOrder.materialAlertsGroups)) {
                <app-tooltip [dynamic]="false" class="display-inline-flex"
                  [message]="getMaterialAlertsTooltip(item.specialOrder.materialAlertsGroups)">
                  <span data-cy="spo-list-spo-alerts-dot">
                    <app-status-dot class="alerts"></app-status-dot>
                  </span>
                </app-tooltip>
                <span class="spo-list-element-alerts"
                data-cy="spo-list-element-alerts">{{getMaterialAlertsText(item.specialOrder.materialAlertsGroups)}}</span>
              }
            </td>
            <td class="list-element">
              <span class="list-element-menu" data-cy="spo-list-element-menu" ngbDropdown>
                <app-tooltip [dynamic]="false" class="display-inline-flex" message="SPO actions">
                  <span class="iwp-icon-gen_kontextmenu" ngbDropdownToggle></span>
                </app-tooltip>
                <div ngbDropdownMenu>
                  @if (userService.hasPermissions([Permission.PARTNER_SPO_SEND])) {
                    <div (click)="contextMenuSend(item.specialOrder, item.contextMenuOptions)"
                      [class.disable]=disableContextMenuSendAction(item.contextMenuOptions)
                      data-cy="spo-list-element-menu-submit"
                    ngbDropdownItem>{{this.spoActionsUtilService.getContextMenuSendButtonText(item.contextMenuOptions.canRetry)}}</div>
                  }
                  @if (userService.hasPermissions([Permission.PARTNER_SPO_EDIT])) {
<div (click)="item.contextMenuOptions.canEdit
                                        && contextMenuEdit(item.specialOrder.number)"
                      [class.disable]=!item.contextMenuOptions.canEdit
                      data-cy="spo-list-element-menu-edit"
                    ngbDropdownItem>Edit</div>
                  }
                  @if (userService.hasPermissions([Permission.PARTNER_SPO_VIEW, Permission.ADMIN_SPO_VIEW])) {
                    <div
                      [routerLink]="[item.specialOrder.number]"
                      data-cy="spo-list-element-menu-view"
                    ngbDropdownItem>View detail</div>
                  }
                  <div class="separator"></div>
                  @if (userService.hasPermissions([Permission.PARTNER_SPO_DELETE])) {
                    <div (click)="deleteSpo(item.specialOrder.number, item.contextMenuOptions.canDelete)"
                      [class.disable]=!item.contextMenuOptions.canDelete
                      data-cy="spo-list-element-menu-delete"
                    ngbDropdownItem>Delete</div>
                  }
                </div>
              </span>
            </td>
          </tr>
          <tr>
            <td [colSpan]="getSpoMaterialListTableColspan()">
              <div [ngbCollapse]="!item.isOpen" class="accordion-materials-list"
                data-cy="spo-list-material-list">
                <app-material-list [enableTableLoading]="true"
                  [materials]="item.specialOrder.specialOrderMaterials"
                  [maxElements]="10"
                  [showBtnAdd]="false"
                  [showExtraColumns]="item.specialOrder.status.code !== specialOrderStatus.DRAFT"
                  [showTooltipWarnings]="false"
                  [spoNumber]="item.specialOrder.number"
                [transportDocumentType]="$safeNavigationMigration(item.specialOrder.transportMode?.transportDocumentType)"></app-material-list>
              </div>
            </td>
          </tr>
        }
      </tbody>
    }
  </table>
  @if (tableIsLoading) {
    <div class="spinner-container" data-cy="loading-spinner-overlay">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

</div>

@if (specialOrderItems?.length == 0) {
  <div class="list-empty">
    <div class="list-empty-icon list-empty-icon-spo"><span class="iwp-icon-iwp_task"></span></div>
    <div class="list-empty-description">The special order list is empty</div>
  </div>
}

@if (showPagination()) {
  <app-pagination (pageNumber)="changePage($event)"
    [page]="spoSearchCriteriaService.pageNumber"
    [collectionSize]="spoSearchCriteriaService.totalResults"
    [pageSize]="spoSearchCriteriaService.pageSize"
    class="spo-list-pagination"
    data-cy="spo-list-pagination">
  </app-pagination>
}

